import { render, staticRenderFns } from "./ClientAppointmentReminders.vue?vue&type=template&id=1d55edcd"
import script from "./ClientAppointmentReminders.vue?vue&type=script&lang=js"
export * from "./ClientAppointmentReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports